import { render, staticRenderFns } from "./myDownload.vue?vue&type=template&id=2b5ec44d&scoped=true&"
import script from "./myDownload.vue?vue&type=script&lang=js&"
export * from "./myDownload.vue?vue&type=script&lang=js&"
import style0 from "./myDownload.vue?vue&type=style&index=0&id=2b5ec44d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b5ec44d",
  null
  
)

export default component.exports